import { render, staticRenderFns } from "./HomeAvmApplication.vue?vue&type=template&id=2bf4b8dc&scoped=true"
import script from "./HomeAvmApplication.vue?vue&type=script&lang=js"
export * from "./HomeAvmApplication.vue?vue&type=script&lang=js"
import style0 from "./HomeAvmApplication.vue?vue&type=style&index=0&id=2bf4b8dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf4b8dc",
  null
  
)

export default component.exports